<template lang='pug'>
  blue-layout( :user='user' :account='account' :biz='biz' )
    bf-notice( :message='message' @close='message = ""' )

    template(v-slot:default='props')
      bf-modal#congrats-modal( :show='services.length == 1 && !account.serviceadded' )
        .container.wider.centered-text
          h3.heading {{$t("Congratulation!")}}
          p {{$t("Your have added your first item!")}}
          span {{$t("Now you may add a coupon or a customer!")}}

          bf-divider.section

          h4 {{ $t("Next Step")}}
          p
            span {{$t("Add a coupon")}},
            router-link.link(:to='{ name: "marketing"}')
              span(@click='seen') {{ $t("click here!")}}
          p
            router-link( :to='{ name: "marketing"}' )
              img(src='/ui/addmarketing.png' width="360" @click='seen')
          p
            h4 {{ $t("Or" )}}
          p
            span {{$t("Add a customer")}},
            router-link.link(:to='{ name: "customers"}')
              span(@click='seen') {{ $t("click here!")}}
          p
            router-link( :to='{ name: "customers"}' )
              img(src='/ui/addcustomer.png' width="360" @click='seen')
          p
            span.skip( @click='seen' ) {{ $t("Skip")}}
          
      base-modal#new-category-form( :show='show.category'  :scrolled='props.scrolled' )
        modal-wrapper( @close='show.category = false' )
          template( v-slot:header )
            h5 {{ $t('Manage Categories') }}
          
          template( v-slot:contents )
            .categories
              bf-flex.centered.new.category
                .left
                  input( type='checkbox' ref='new' v-model='category.active' hidden )
                  bf-flex.centered.check-circle( @click.native='$refs.new.click()' :class='{ active: category.active }' )
                    check-icon( v-show='category.active' )
                .center
                  bf-input.basic
                    input( 
                      type='text' 
                      v-model='category.title' 
                      :placeholder="$t('Type Something Here')" 
                      @keyup.enter='$refs.add.click()'
                    )
                .right.actionable( ref='add' @click='set' )
                  add-icon

              bf-flex.centered.category( v-for='c, i in categories' :key='c.id' )
                .left
                  bf-flex.centered.check-circle( @click.native='activate( c )' :class='{ active: c.active }' )
                    check-icon( v-show='c.active' )
                .center
                  bf-input.basic
                    input( type='text' v-model='c.title' @change='update( c )' )
                .right.actionable( @click='remove( c )' )
                  remove-icon

      #services.view
        section#category
          bf-wrapper.content
            bf-flex.centered
              label {{ $t('Show Category') }}: 
              select.servtype(v-model='selected')
                option(value='all') {{ $t('Display All') }}
                option( v-for='c in active_categories' :value='c' :key='`active-${c.id}`' ) {{ c.title }}
              bf-button.hilite(v-if="hilite=='cat'" @click.native='show.category = true')
                template(v-slot:text) {{ $t('Manage') }}
              bf-button(v-else @click.native='show.category = true')
                template(v-slot:text) {{ $t('Manage')}} 

        section#tabs
          bf-wrapper.content
            bf-flex.tabs
              router-link.tab( :to='{ name: "services" }' ) {{$t("Service")}}
              router-link.tab( :to='{ name: "products" }' ) {{$t("Product")}}
              router-link.tab( :to='{ name: "catalogs" }' ) {{$t("Menu/Catalog")}}

        section#items
          bf-wrapper.content
            router-view(
              v-if='account.id && biz && biz.id'
              ref='view'
              :user='user'
              :account='account'
              :biz='biz'
              :categories='active_categories'
              :category='selected'
              @categorize='categorize'
            )
</template>

<script>
  import { db } from '@/main'
  import { View } from '@/mixins/view'
  import MerchantServices from '@/components/merchant-services'
  import BaseModal from '@/components/modals/base'
  import ModalWrapper from '@/components/modals/wrapper'

  export default {
    name: 'selling.view',

    mixins: [ View ],

    components: {
      MerchantServices,
      BaseModal,
      ModalWrapper
    },

    data() {
      return {
        message: '',
        categories: [],
        services: [],
        selected: 'all',
        category: { active: true },
        show: { category: false },
        newbox: true,
        title: '',
        key: 0,
        hilite:  this.$route.params.hilight
      }
    },

    computed: {
      active_categories() {
        return this.categories.filter( c => c.active )
      }
    },

    watch: {
      account( curr, prev ) {
        if ( curr.id ) this.$binding(
          'categories',
          db.collection('categories').where( 'account_id', '==', this.account.id )
        )
      }
    },

    firestore() {
      if ( this.account.id )
        return {
          services: db.collection("services").where( 'business_id', '==', this.biz.id ),
          categories: db.collection('categories').where( 'account_id', '==', this.account.id )
        }
    },

    methods: {
      seen() {
        db.collection( 'accounts' ).doc( this.account.id ).update({ serviceadded: true })
      },

      categorize() {
        console.log('index categorize:  this.show', this.show )
        this.show.category = true
      },

      notify( msg ) {
        this.message = msg
      },

      set() {
        this.category.account_id = this.account.id
        if ( !this.category.title ) return
        db.collection('categories').add( this.category ).then( () => {
          this.notify(`"${this.category.title}" has been added as a category`)
          this.category = { active: true }
        })
      },

      activate(c) {
        c.active = !c.active
        this.update(c)
      },

      update(c) {
        db.collection('categories').doc( c.id ).set( c, {merge: true} )
      },

      remove(c) {
        db.collection('categories').doc( c.id ).delete()
      }
    },

    created() {
      if ( !this.account.merchant ) this.$router.push({ name: 'upgrade' })
    }
  }

</script>

<style scoped lang='stylus'>
  #tabs .bf-wrapper
    background rgb( 255 255 255 )
    border 1px solid rgb( 200 200 200 )
    border-radius 5px
    padding 8px
    margin-top 32px
    font-weight bold

  .tabs
    max-width 480px
    margin 0 auto
    font-size 1.2em
    align-items center
    justify-content space-between
    .tab
      padding 4px 12px
      border-radius 3px
    .router-link-exact-active
      background orange
      color white

    .add-button
      .icon
        border-radius 50%
        color rgb( 90 90 90 )
        background white
        height 33px
        width 35px
        padding-top 2px
        margin-right 10px
        
  #new-category-form
    .category
      margin-top 16px
      &:first-child
        margin 0
      &.new
        .right
          font-size 2.25em
          padding 0
        .left
          padding 0
      .right
        font-size 1.8em
        color rgb( 55 70 100 )
        text-align right
        padding 0 3px
        padding-left 6px
      .left
        padding-right 3px
      .center
        flex-grow 1
        margin 0 4px
    .check-circle
      border-radius 50%
      border 1px solid
      height 12px
      width 16px
      padding-bottom 4px
      &.active
        background rgb( 100 150 75 )
        color white
        border-color rgb( 100 150 75 )

  #category
    padding 0 0 12px 0
    box-shadow 0 2px 3px 0 rgba( 0 0 0 .1 )
    .content
      position relative
    label
      margin-left 8px
      font-size 1.1em
    select
      color black
      font-size 1.1em
      width auto
      padding-left 10px
      margin-right 16px
    .edit
      margin-right auto
</style>
